import PluginDept from './PluginDept';
import './style/index.less';

export { default as PluginDeptSelect } from './components/plugin-dept-select';

export default PluginDept;
